// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__1eY_u","Label":"Checkbox_Label__3ONZ8","InputElement":"Checkbox_InputElement__2VsjV","Invalid":"Checkbox_Invalid__1RtJz"};